// @ts-check
import { useSettingRef } from '@erpagroapp/settings';
import axios from 'axios';
import { IS_DEVELOPMENT, IS_WEB } from '../common/constants';
import { useAppConfigStore } from '../stores/appConfig';

/** @import { AxiosInstance, AxiosRequestConfig } from 'axios' */

export const ApiModule = Object.freeze({
  Login: '/api/Login',
  Global: '/api/Global',
  Security: '/api/Seguridad',
  Apps: '/api/apps',
  Alerts: '/api/AlertaNotificacion',
  Common: '/api/comun',
  Production: '/api/Produccion',
  Traceability: '/api/Trazabilidad',
  Presence: '/api/Presencia',
  Commercialization: '/api/Comercializacion',
  Picking: '/api/Picking',
  Repairs: '/api/Repairs',
  Warehouse: '/api/Almacen',
  Sales: '/api/Ventas',
  Shopping: '/api/Compras',
  BusinessManagement: '/api/GestionNegocio',
  AgroCommon: '/api/AgroComun',
  Reports: '/api/Informes',
  PurchaseContracts: '/api/AppContratosCompraCampo',
  Alhondigas: '/api/Alhondigas',
});

/**
 * Extracts the last part of a URL to be used as a proxy route.
 * @param {string} realApiUrl - The real API URL.
 * @returns {string} The extracted proxy route.
 */
export function getProxyRoute(realApiUrl) {
  const words = realApiUrl.split('/');
  let lastWord = words[words.length - 1];

  if (lastWord === '') {
    lastWord = words[words.length - 2];
  }

  return `/${lastWord}`;
}

/**
 * Retrieves the host API URL from the store and constructs the API URL considering the environment and target.
 * @returns {string} The constructed host API URL.
 */
function getHostApiERP() {
  const urlApp = useSettingRef('App.URLWebService');
  const urlAppOrEmpty = urlApp.value ?? '';

  const useProxy = IS_DEVELOPMENT && IS_WEB;
  return useProxy ? getProxyRoute(urlAppOrEmpty) : urlAppOrEmpty;
}

/**
 * Retrieves the ERP access token from the store and constructs headers for API requests.
 */
function getTokenERP() {
  const store = useAppConfigStore();
  const headers = {
    'Authorization': store.getAccessTokenERP,
    'Content-Type': 'application/json',
  };

  return headers;
}

/**
 * Creates an Axios client with the specified configuration.
 * @param {AxiosRequestConfig} [config] - The Axios configuration.
 * @returns {AxiosInstance} The created Axios instance.
 */
export const httpClient = (config = undefined) => axios.create({
  baseURL: getHostApiERP(),
  headers: getTokenERP(),
  ...config,
});
